<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <linearGradient
      id="gradient"
      x1="22.4602"
      y1="0.0996092"
      x2="7.57649"
      y2="22.0373"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#FF00D6" />
      <stop offset="1" stop-color="#0072DB" />
    </linearGradient>
    <path
      d="M10.09 15.59L11.5 17L16.5 12L11.5 7L10.09 8.41L12.67 11H3V13H12.67L10.09 15.59ZM19 3H5C3.89 3 3 3.9 3 5V9H5V5H19V19H5V15H3V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
      fill="url(#gradient)"
      fill-opacity="0.87"
    />
  </svg>
</template>
